import request from '@/services/helpers/request';
import { API_ROUTES } from '@/config';

export const authService = {
  login: async formData => (await request.getInstance()).post(API_ROUTES.auth.login, formData)
};
